import i18n from '@/i18n/i18n';
import Vue from 'vue'
import { colors } from 'vuetify/lib';
import Vuetify from 'vuetify/lib/framework'

import en from 'vuetify/lib/locale/en'
import es from 'vuetify/lib/locale/es'

Vue.use(Vuetify)

export default new Vuetify({
	rtl: false,
	lang: {
		locales: { en, es },
		current: i18n.locale,
	},
	theme: {
		themes: {
			light: {
				primary: '#015931', // #015931 #083866
				bgColor: '#f3f7f8',
				secondary: '#a7a7a7', // #FFCDD2
				success: '#13a689',
				'add-color': '#015931',
				'warning-color': colors.orange.darken2,
				'alert-color': colors.red.lighten1,
				'preview-color': colors.deepPurple.lighten1,
				error: '#ff3334',
				errorLight: '#eeb4b3',
				main: colors.grey.darken3,
				darkGreen: colors.green.darken1
			}
		},
	},
	icons: {
		values: {
			add: 'mdi-plus-circle-outline',
			view: 'mdi-eye',
			edit: 'mdi-pencil',
			close: 'mdi-close',
			delete: 'mdi-delete',
			search: 'mdi-magnify',
			info: 'mdi-information',
			alert: 'mdi-alert-octagon-outline',
			back: 'mdi-arrow-left',
			check: 'mdi-check-circle-outline',
			calendar: 'mdi-calendar',
			checkCircleOutline: 'mdi-check-circle-outline',
			progressHelper: 'mdi-progress-helper',
			compare: 'mdi-compare'
		},
	}
})
